import {
    IonBackButton,
    IonButton,
    IonButtons,
    IonCol,
    IonContent,
    IonHeader,
    IonModal,
    IonPage,
    IonRow,
    IonText,
    IonTitle,
    IonToolbar,
    isPlatform
} from "@ionic/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { assignUserToForm } from "../../store/formsubmitted/actions/assignUserToForm";
import { setCreateStatus } from "../../store/massiveDocumentCreate";
import { findSelectedUsers } from "../../store/massiveDocumentCreate/actions/findSelectedUsers";
import { createAllAutomatticDocuments } from "../../store/userTemplate/actions/createAllAutomatticDocuments";
import { findAutomatticTemplates } from "../../store/userTemplate/actions/findAutomatticTemplates";
import { findTemplateName } from "../../store/userTemplate/actions/findTemplateName";
import { findUserRoleCode } from "../../store/userTemplate/actions/findUserRoleCode";
import { selectAutomatticTemplatesCount } from "../../store/userTemplate/selectors/selectAutomatticTemplatesCount";
import { selectTemplateName } from "../../store/userTemplate/selectors/selectTemplateName";
import { selectUserRoleCode } from "../../store/userTemplate/selectors/selectUserRoleCode";
import { UserTablePreview } from "../MassiveDocumentCreate/components/UserTablePreview";
import { AssignAndGenerateDocuments } from "./components/AssignAndGenerateDocuments";
import { AssignUserStatus } from "./components/AssignUserStatus";
import { ModalHeader } from "./components/ModalHeader";

const colStyle = {
    maxWidth: "450px",
    padding: "20px"
}

export const UserAssociateTemplate = () => {
    const { id }: { id: string } = useParams();
    const { template }: { template: string } = useParams();
    const dispatch = useDispatch();
    const [disableButtons, setDisableButtons] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const userRoleCode = useSelector(selectUserRoleCode);
    const templateName = useSelector(selectTemplateName);
    const automatticTemplatesCount = useSelector(selectAutomatticTemplatesCount);

    useEffect(() => {
        dispatch(setCreateStatus(""));
        dispatch(findTemplateName(template));
        dispatch(findAutomatticTemplates(template));
        dispatch(findUserRoleCode(id));
    }, []);

    function dismissModal() {
        setShowModal(false);
    }

    const handleDataPreview = async () => {
        await dispatch(findSelectedUsers(userRoleCode));
        setShowModal(true);
    }

    const handleAssociateTemplate = async () => {
        setDisableButtons(true);
        await dispatch(assignUserToForm({ template: template, user: id }));
    }

    const handleAssociateTemplateWithAgreement = async () => {
        setDisableButtons(true);
        await dispatch(createAllAutomatticDocuments({ template: template, userId: id, assign: true }));
    }

    return (
        <IonPage>
            <IonHeader class="ion-no-border">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton
                            text={isPlatform("ios") ? "Usuario" : ""}
                            defaultHref={`/app/rrhh/usuarios/acuerdos/${id}`}
                            color="light"
                        />
                    </IonButtons>
                    <IonTitle>Asociar plantilla</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <section className="ion-padding">
                    <IonRow class="ion-justify-content-around">
                        <IonCol class="ion-text-center" style={colStyle}>
                            <h4>Plantilla: {templateName}</h4>

                            <IonText class="ion-text-center">
                                {automatticTemplatesCount > 0 && `Esta plantilla tiene ${automatticTemplatesCount} acuerdos digitales automáticos.`}
                                {automatticTemplatesCount === 0 && `¿Desea asociar esta plantilla al usuario?`}
                            </IonText>
                            <br />
                            <br />
                            <IonButton
                                expand="block"
                                disabled={disableButtons}
                                onClick={handleDataPreview}
                            >
                                Ver vista previa de los datos
                            </IonButton>
                            <br />
                            <IonButton
                                expand="block"
                                disabled={disableButtons}
                                onClick={handleAssociateTemplate}
                            >
                                {automatticTemplatesCount > 0 && "Asociar sin crear acuerdos"}
                                {automatticTemplatesCount === 0 && "Asociar plantilla al usuario"}

                            </IonButton>
                            <br />
                            {automatticTemplatesCount > 0 &&
                                <IonButton
                                    expand="block"
                                    disabled={disableButtons}
                                    onClick={handleAssociateTemplateWithAgreement}
                                >
                                    Asociar y crear acuerdos
                                </IonButton>
                            }

                        </IonCol>
                    </IonRow>
                </section>
            </IonContent>

            <AssignUserStatus />
            <AssignAndGenerateDocuments />

            <IonModal isOpen={showModal} onDidDismiss={() => setShowModal(false)}>
                <ModalHeader title="Vista Previa" dismissModal={dismissModal} />
                <IonContent>
                    <UserTablePreview title="Datos del usuario" />
                </IonContent>
            </IonModal>
        </IonPage >
    )
}